import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { AccountInfo } from '@azure/msal-browser';
import { MsalService } from '@azure/msal-angular';
@Directive({
  selector: '[hasRole]',
})
export class HasroleDirective implements OnInit {
  @Input()
  hasRole: string[] = [];
 
  hasView = false;
  userRoles: string[] = [];
 
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private msalService: MsalService
  ) {}
  ngOnInit(): void {
    const account: AccountInfo | null = this.msalService.instance.getActiveAccount();
    if (account && account.idTokenClaims) {
      this.userRoles = account.idTokenClaims['roles'] || [];
      this.userRoles = this.userRoles.flatMap(role => role.split(','));
    }
    for (const role of this.hasRole) {
      if (this.userRoles.includes(role)) {
        this.hasView = true;
        break;
      }
    }
 
    if (!this.hasView) {
      this.viewContainer.clear();
    } else {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
 